<template>
	<div class="row">
		<div class="col-md-12">
			<tasks-datatable
				ref="datatable"
				@reload="reload"
				:project="item"
				:user="user"
				:isAuth="isAuth">
			</tasks-datatable>
		</div>
	</div>
</template>

<script>
	import TasksDatatable from '@/components/projects/tasks/views/Datatable.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'tasks-datatable': TasksDatatable,
		},
		data () {
			return {
			}
		},
		watch: {
			item() {
				this.$refs.datatable.reload()
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Tasks.vue